<template>
    <div class="video-background">
      <video class="background-video" autoplay muted loop>
        <source src="../../public/video.mp4" type="video/mp4">
  
      </video>
      <div class="content-overlay" style="display: flex;flex-direction: column;align-items: center;">
        
        <img src="../../public/logonew.png" alt="" style="margin-top:200px">
        <img src="../../public/topbt.png" alt="" style="margin-top:290px;width:64px;cursor: pointer;">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VideoBackground',
  };
  </script>
  
  <style scoped>
  .video-background {
    position: relative;

    width: 100%;
    height: 100%; /* 或其他你想要的高度 */
    overflow: hidden;
  }
  
  .background-video {
    position: absolute;
    background-color: transparent;
    width: 100%;
    z-index: 111;
    /* transform: translate(-%, -%); */
  }
  
  .content-overlay {
    position: relative;
    z-index:1000 ;
    /* 其他样式，如背景色、透明度等，根据需要调整 */
  }
  </style>
  